<template>
<div>
    <p>Sénateur Gauche</p>
</div>
</template>

<script>
  import {mixin} from "./Senateur.mixin";

  export default {
    mixins: [mixin]
  };
</script>

<style>

</style>


// WEBPACK FOOTER //
// SenateurGauche.vue?65be4b5c